/**
 * FormButtons Component.
 * Its Wrapper Component for Kepler `Button` Component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'kepler/lib/components/Button';

class FormButtons extends Component {
  // Get the Submit Button.
  getSubmitButton() {
    return (
      <Button className="submit-btn" submit>
        <div className="submit-text">{this.props.submitLabel}</div>
      </Button>
    );
  }

  // Get the Cancel Button.
  getCancelButton() {
    if (!this.props.hasCancelButton) {
      return null;
    }
    return (
      <Button className="cancel-btn" type="secondary" onClick={this.props.handleCancel}>
        {this.props.resetLabel}
      </Button>
    );
  }

  // Render the Form Buttons Component.
  render() {
    return (
      <div className="form-btns">
        <div className={this.props.submitButtonStyle}>{this.getSubmitButton()}</div>
        <div className={this.props.cancelButtonStyle}>{this.getCancelButton()}</div>
      </div>
    );
  }
}

// FormButtons Props Types.
FormButtons.propTypes = {
  hasCancelButton: PropTypes.bool,
  submitLabel: PropTypes.string,
  resetLabel: PropTypes.string,
  handleCancel: PropTypes.func.isRequired,
  submitButtonStyle: PropTypes.string,
  cancelButtonStyle: PropTypes.string,
};

// EmailUs Props default values.
FormButtons.defaultProps = {
  submitLabel: 'Submit',
  resetLabel: 'Cancel',
  hasCancelButton: true,
  submitButtonStyle: 'left-col col-xs-6 col-sm-6 col-md-4 col-lg-3',
  cancelButtonStyle: 'right-col col-xs-6 col-sm-6 col-md-4 col-lg-3',
};

export default FormButtons;
